import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Fleet from '../components/Fleet';
import HowItWorks from '../components/HowItWorks';
import Requirements from '../components/Requirements';
import FAQ from '../components/FAQ';
import BookingCTA from '../components/BookingCTA';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <>
      <Hero />
      <Fleet />
      <HowItWorks />
      <Requirements />
      <FAQ />
      <BookingCTA />
      <Contact />
      <Footer />
    </>
  );
}